import * as types from './mutation-types'

const mutations = {
  [types.SET_CUSTOMERS] (state, customers) {
    state.customers = customers
  },
  [types.SET_PICKER_OPTIONS] (state, pickerOptions) {
    state.pickerOptions = pickerOptions
  },
  [types.SET_ORG_TYPES] (state, orgTypes) {
    state.orgTypes = orgTypes
  },
  [types.SET_ORG_CLASSES] (state, orgClasses) {
    state.orgClasses = orgClasses
  },
  [types.SET_MODE_LIST] (state, modeList) {
    state.modeList = modeList
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js